import createReducer from "../../lib/createReducer";
import * as types from "../../actions/types";

const initialState = {
  items: [],
  createdItem: null,
  deletedItem: null,
};

export default createReducer(initialState, {
  [types.VEHICLES_SET_ORDER_CATEGORIES](state, action) {
    const newState = JSON.parse(JSON.stringify(state));

    newState.items = action.state.items;

    return newState;
  },

  [types.VEHICLES_SET_CREATED_ORDER_CATEGORY](state, action) {
    const newState = JSON.parse(JSON.stringify(state));

    newState.createdItem = action.state.item;
    newState.items.unshift(newState.createdItem);

    return newState;
  },

  [types.VEHICLES_SET_DELETED_ORDER_CATEGORY](state, action) {
    const newState = JSON.parse(JSON.stringify(state));

    const { item } = action.state;
    newState.deletedItem = item;
    newState.items = newState.items.filter((i) => i.name !== item.name);

    return newState;
  },
});
